$(document).ready(() => {

    $('.ammenu-submenu-container.ammenu-submenu.-full')
    .on('mouseenter', function(e) {
        $(e.currentTarget)
            .prev()
            .addClass('hover');
    })
    .on('mouseleave', function(e) {
        $(e.currentTarget)
            .prev()
            .removeClass('hover');
    });

    // KREAN-1097 Mobile nav. Fix for dropdown scroll position after opening.
    $(document).on('click', '.ammenu-toggle', (e) => {
        const target = e.target;

        setTimeout(() => {
            if (target.getBoundingClientRect().bottom > window.innerHeight) {
                target.scrollIntoView(false);
            }

            // scroll the menu into view if needed.
            if (target.getBoundingClientRect().top < 0) {
                // selecting the previous item to make sure that the current item is not covered by the header.
                $(target).closest('.ammenu-item').prev()[0].scrollIntoView();
            }
        }, 50);

    });
})


